export enum Role {
    Institute = 'Institute',
    Reseller = 'Reseller',
    countryAdmin = 'CountryAdmin',
    globalAdmin = 'GlobalAdmin',
    branchAdmin = 'branchAdmin',
    Branch = 'Branch'
  }
